import { CometChat } from "@cometchat/chat-sdk-javascript";

export const initializeCometChat = async () => {
  try {
    const appId = process.env.REACT_APP_COMETCHAT_APP_ID;
    const region = process.env.REACT_APP_COMETCHAT_APP_REGION;
    
    if (!appId || !region) {
      throw new Error("CometChat configuration missing");
    }

    const appSettings = new CometChat.AppSettingsBuilder()
      .subscribePresenceForAllUsers()
      .setRegion(region)
      .build();
    
    await CometChat.init(appId, appSettings);
    console.log("CometChat initialized successfully");
    return true;
  } catch (initError) {
    if (initError.code === 'ALREADY_INITIALIZED') {
      console.log("CometChat already initialized");
      return true;
    }
    console.error("CometChat initialization failed:", initError);
    throw initError;
  }
};

export const ensureCometChatReady = async () => {
  try {
    await initializeCometChat();
    
    let loggedInUser = await CometChat.getLoggedinUser();
    
    if (!loggedInUser) {
      console.log("No CometChat user logged in, attempting authentication...");
      
      const authKey = process.env.REACT_APP_COMETCHAT_AUTH_KEY;
      const userId = localStorage.getItem("user_id");
      
      if (!authKey || !userId) {
        throw new Error("Missing CometChat authentication credentials");
      }

      loggedInUser = await CometChat.login(userId, authKey);
      console.log("CometChat authentication successful:", loggedInUser.uid);
    }
    
    return loggedInUser;
  } catch (error) {
    console.error("CometChat setup failed:", error);
    throw error;
  }
};

export const updateProfilePicture = async (base64Image) => {
  try {
    await ensureCometChatReady();

    const response = await Promise.race([
      CometChat.callExtension(
        'avatar',
        'POST',
        'v1/upload',
        {
          avatar: base64Image,
        }
      ),
      new Promise((_, reject) => 
        setTimeout(() => reject(new Error("CometChat avatar upload timeout")), 15000)
      )
    ]);
    return response;
  } catch (error) {
    throw error;
  }
};


export const updateUserName = async (newName) => {
  try {
    console.log("updateUserName started for:", newName);
    const loggedInUser = await ensureCometChatReady();
    console.log("loggedInUser", loggedInUser)
    const authKey = process.env.REACT_APP_COMETCHAT_AUTH_KEY;
    const user = new CometChat.User(loggedInUser?.uid);
    user.setName(newName);

    const updatedUser = await Promise.race([
      CometChat.updateUser(user, authKey),
      new Promise((_, reject) => 
        setTimeout(() => reject(new Error("CometChat updateUser timeout")), 10000)
      )
    ]);
    console.log("Username updated successfully");
    return updatedUser;
  } catch (error) {
    if (!error.message.includes("timeout")) {
      console.log("updateUserName error:", error);
    }
    throw error;
  }
}
